import axios from 'axios';
import i18next from 'i18next';
import { RateLimitedError } from '../services/api';

/** What to tell the user when an action failed: how long to wait when it was rate-limited, otherwise `fallback`. */
export function actionFailureMessage(error: unknown, fallback: string): string {
  return rateLimitMessage(error) ?? fallback;
}

/** How long to wait, when the action was rate-limited; null for any other failure. */
export function rateLimitMessage(error: unknown): string | null {
  return error instanceof RateLimitedError ? i18next.t('errors.rateLimited', { count: error.retryAfterSeconds }) : null;
}

export function chatFailureMessage(error: unknown, fallback: string): string {
  return isProjectAlreadyRunningError(error)
    ? 'Another chat in this project is already running. Wait for it to finish.'
    : actionFailureMessage(error, fallback);
}

function isProjectAlreadyRunningError(error: unknown): boolean {
  return (
    axios.isAxiosError(error) &&
    error.response?.status === 409 &&
    (error.response.data as { error?: string } | undefined)?.error === 'project_already_running'
  );
}
